export const ProviderInviteStatuses = {
  pending: 'Pending',
  cancelled: 'Cancelled',
};

export const ProviderInviteStatusesLowerCase = Object.fromEntries(
  Object.entries(ProviderInviteStatuses).map(([key, value]) => [key, value.toLowerCase()]),
);
